import { type TableColumnSpec } from "#blocks/Table/buildTableColumns"
import { StudentForTable } from "#customTypes/composedTypes/studentTypes"

export const STUDENT_TABLE_COLUMNS: TableColumnSpec[] = [
  { key: "dob", width: 64, align: "center" },
  { key: "name", width: 250 },
  { key: "skillLevels", width: 200 },
  { key: "guardian1Phone", width: 230 },
  { key: "guardian1Email", width: 200 },
  { key: "tags", width: 120, ellipsis: false },
  { key: "allergies", width: 120, ellipsis: false },
  { key: "lastUpdatedAt", width: 140, title: "Last Updated" },
]

export const STUDENT_SEARCHABLE_FIELDS: (keyof StudentForTable)[] = [
  "name",
  "dob",
  "skillLevels",
] as const

export const STUDENT_SORTABLE_FIELDS = [
  "name",
  "skillLevels",
  "lastUpdatedAt",
] as const

/**
 * Default allergy options used to seed the Firestore allergies collection.
 * Once seeded, the source of truth is the DB — these are only for initial population.
 */
// export const DEFAULT_ALLERGY_OPTIONS = [
//   { value: "peanuts", label: "Peanuts", icon: "🥜" },
//   { value: "treeNuts", label: "Tree nuts", icon: "🌰" },
//   { value: "milk", label: "Milk", icon: "🥛" },
//   { value: "eggs", label: "Eggs", icon: "🥚" },
//   { value: "gluten", label: "Gluten", icon: "🍞" },
//   { value: "wheat", label: "Wheat", icon: "🌾" },
//   { value: "soy", label: "Soy", icon: "🌱" },
//   { value: "fish", label: "Fish", icon: "🐟" },
//   { value: "shellfish", label: "Shellfish", icon: "🦞" },
//   { value: "pollen", label: "Pollen", icon: "🌼" },
//   { value: "dustMites", label: "Dust Mites", icon: "🕸️" },
//   { value: "mold", label: "Mold", icon: "🍄" },
//   { value: "animalDander", label: "Animal Dander", icon: "🐾" },
//   { value: "cockroachAllergens", label: "Cockroach Allergens", icon: "🪳" },
//   { value: "beeStings", label: "Bee Stings", icon: "🐝" },
//   { value: "waspStings", label: "Wasp Stings", icon: "🐝" },
//   { value: "penicillin", label: "Penicillin", icon: "💊" },
//   { value: "aspirin", label: "Aspirin", icon: "💊" },
//   { value: "latex", label: "Latex", icon: "🧤" },
//   { value: "poisonIvy", label: "Poison Ivy", icon: "🌿" },
//   { value: "fragrances", label: "Fragrances", icon: "🌸" },
//   { value: "householdCleaners", label: "Household Cleaners", icon: "🧼" },
// ]
